
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/centre/[centreSlug]/[centreUID]",
      function () {
        return require("private-next-pages/goal/[goalSlug]/[goalUID]/centre/[centreSlug]/[centreUID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/[goalUID]/centre/[centreSlug]/[centreUID]"])
      });
    }
  